/* gl_checkbox.directive.js */

var _ = require("lodash");
/* globals angular */
module.exports = function ($compile, $timeout) {
    "use strict";

    return {
        restrict: "E",
        scope: {
            settings: "=",
            api: "=",
        },

        link: function (scope, element, attrs, controller) {
            var elementInput;
            var elementInputLabel;
            var elementError;
            var elementViewLabel;
            var elementViewValue;
            var classInvalid = "gl-invalid";
            var classChecked = "gl-checkbox-checked";
            var classVariedChecked = "gl-checkbox-varied-checked";
            var classDisabled = "gl-checkbox-disabled";

            // internal settings
            scope._settings = {
                id: undefined,
                name: undefined,
                value: false,
                title: undefined,
                viewLabel: "On",
                valid: true,
                error: undefined,
                label: undefined,
                labelChecked: "On",
                labelUnChecked: "Off",
                labelVariedChecked: false,
                disabled: false,
                editable: true,
                onChange: undefined,
                ignoreUser: false,
            };

            _.assignWith(scope._settings, scope.settings);

            // Templates
            var templates = {
                view: {},
                edit: {},
            };
            templates.edit.input = '<input type="checkbox" class="gl-checkbox-input" ';
            templates.edit.input += scope._settings.id ? 'id="{{_settings.id}}" ' : "";
            templates.edit.input += scope._settings.name ? 'name="{{_settings.name}}" ' : "";
            templates.edit.input += "/>";
            templates.edit.inputLabel =
                '<label data-ng-attr-title="{{_settings.title}}" class="gl-checkbox-label" data-ng-bind="_settings.label"></label>';
            templates.view.label =
                '<label class="gl-checkbox-view-label" data-ng-bind="_settings.label"></label>';
            templates.view.value =
                '<p class="gl-checkbox-view-value">{{_settings.value ? _settings.labelChecked : _settings.labelUnchecked}}</p>';
            templates.error = '<p class="gl-checkbox-error" data-ng-bind="_settings.error"></p>';

            scope.api = scope.api || {};

            scope.api.view = function () {
                setViewMode();
            };
            scope.api.edit = function () {
                setEditMode();
            };

            scope.api.setInvalid = function (msg) {
                scope._settings.valid = false;
                if (angular.isString(msg)) {
                    scope._settings.error = msg;
                } else {
                    scope._settings.error = undefined;
                }
                errorMsgCheck();
            };

            scope.api.setValid = function () {
                scope._settings.valid = true;
                errorMsgCheck();
            };
            scope.api.setLabel = function (val) {
                scope._settings.label = val;
            };

            // Programatically setting the value will NOT fire
            // onChange unless you pass a true boolean as the second argument.
            scope.api.setValue = function (val, fireOnChange) {
                //scope.api.setVariedCheckedState(false);
                fireOnChange = _.isBoolean(fireOnChange) ? fireOnChange : false;
                if (val) {
                    scope._settings.value = true;
                    elementInput.attr("checked", true);
                    elementInputLabel.addClass(classChecked);
                } else {
                    scope._settings.value = false;
                    elementInput.removeAttr("checked");
                    elementInputLabel.removeClass(classChecked);
                }

                if (fireOnChange && _.isFunction(scope._settings.onChange)) {
                    scope._settings.onChange(scope._settings.value);
                }
            };

            scope.api.setVariedCheckedState = function (checked, alertUser) {
                var alert = !_.isUndefined(alertUser) ? alertUser : false;
                if (checked === true) {
                    elementInputLabel.addClass(classVariedChecked);
                    scope.api.setValue(true, alert);
                } else {
                    elementInputLabel.removeClass(classVariedChecked);
                    scope.api.setValue(false, alert);
                }
            };

            scope.api.getValue = function () {
                return scope._settings.value;
            };

            scope.api.disable = function () {
                scope._settings.disabled = true;
                elementInput.attr("disabled", true);
                elementInputLabel.addClass(classDisabled);
            };

            scope.api.enable = function () {
                scope._settings.disabled = false;
                elementInput.removeAttr("disabled");
                elementInputLabel.removeClass(classDisabled);
            };

            var setEditMode = function () {
                scope._settings.editable = true;
                element.children().remove();
                elementInput = angular.element(templates.edit.input);
                elementInputLabel = angular.element(templates.edit.inputLabel);
                elementInputLabel.on("click", function () {
                    if (scope._settings.ignoreUser) {
                        return;
                    }
                    if (angular.isUndefined(elementInput.attr("disabled"))) {
                        var newVal = angular.copy(!scope._settings.value);
                        scope.api.setVariedCheckedState(false, false);
                        scope.api.setValue(newVal, true);
                    }
                });
                element.append($compile(elementInput)(scope));
                element.append($compile(elementInputLabel)(scope));
                // if initial value setting is different then the default false value
                if (scope.settings.value === true) {
                    scope.api.setValue(true, false); // do not fire onchange for initial setting
                }
                if (scope._settings.disabled === true) {
                    scope.api.disable();
                }
                if (scope._settings.labelVariedChecked === true) {
                    scope.api.setVariedCheckedState(true);
                }
                errorMsgCheck();
            };

            var setViewMode = function () {
                scope._settings.editable = false;
                scope.api.setVariedCheckedState(false);
                element.children().remove();
                if (angular.isString(scope._settings.label)) {
                    elementViewLabel = $compile(angular.element(templates.view.label))(scope);
                    element.append(elementViewLabel);
                }
                elementViewValue = $compile(angular.element(templates.view.value))(scope);
                element.append(elementViewValue);
            };

            var errorMsgCheck = function () {
                if (!angular.isUndefined(elementError)) {
                    elementError.remove();
                }
                if (scope._settings.editable) {
                    if (scope._settings.valid) {
                        elementInput.removeClass(classInvalid);
                        elementInputLabel.removeClass(classInvalid);
                    } else {
                        elementInput.addClass(classInvalid);
                        elementInputLabel.addClass(classInvalid);
                        if (angular.isString(scope._settings.error)) {
                            $timeout(function () {
                                elementError = $compile(angular.element(templates.error))(scope); // ensure .error has been updated prior to this compile
                                element.append(elementError);
                            }, 0);
                        }
                    }
                }
            };

            if (scope._settings.editable) {
                setEditMode();
            } else {
                setViewMode();
            }
            element.on("$destroy", function () {
                elementInputLabel.unbind();
            });

            scope.$on("$destroy", function () {
                elementInputLabel.unbind();
            });
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['$compile','$timeout'];